import { Grid, Paper, Stack, Typography } from "@mui/material";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import { AppChip } from "../../../../components/chips";

function ProductBlock({ data, editable, onEditClick, onDeleteClick }) {
  return (
    <Paper sx={{ p: 1 }} elevation={2}>
      <Grid container alignItems={"flex-start"}>
        <Grid container item xs={10}>
          <Grid item xs={2} sm={1}>
            {/* <ProductIcon /> */}
          </Grid>
          <Grid item xs={10} sm={11}>
            <Stack mb={1}>
              <Typography className="truncated-text" title={data?.category}>
                {data?.category}
              </Typography>
            </Stack>
            <AppChip
              label={data?.isSatisfied ? "Satisfied" : "Unsatisfied"}
              size="small"
              icon={
                data?.isSatisfied ? (
                  <ThumbUpAltIcon color="info" />
                ) : (
                  <ThumbDownAltIcon color={"error"} />
                )
              }
              bgColor={
                data?.isSatisfied
                  ? "rgba(24, 144, 255, 0.1)"
                  : "rgba(255, 0, 0, 0.1)"
              }
              fontColor={data?.isSatisfied ? "#2F80ED" : "#EB5757"}
            />
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default ProductBlock;
